import { Link } from "@inertiajs/react";
import { useState } from "react";
import ImageFallback from "../../../components/ImageFallback/ImageFallback";
import { Nominee } from "../types";

const TrophyVehicleCard = ({ vehicle }: { vehicle: Nominee }) => {
  const [imageError, setImageError] = useState(false);
  const fullName = `${vehicle.brand.title} ${vehicle.name}`;

  return (
    <Link
      href={vehicle.path}
      className="card"
      aria-label={`Voir la fiche ${fullName}`}
    >
      <div className="ph">
        {imageError || !vehicle.photo_url ? (
          <ImageFallback />
        ) : (
          <img
            src={vehicle.photo_url}
            alt={fullName}
            loading="lazy"
            onError={() => setImageError(true)}
          />
        )}
      </div>
      <div className="meta">
        <div className="mname">{fullName}</div>
        {/* <div className="rate">
          <Star className="star" aria-hidden="true" />
          <b>{vehicle.note?.toLocaleString()}</b>
          <span>/ 10 · {vehicle.reviews_count} avis</span>
        </div> */}
      </div>
    </Link>
  );
};

export default TrophyVehicleCard;
